import { useContext } from 'react'

import DaiOptOutContext from 'contexts/DaiOptOutContext'

const useDaiOptOut = () => {
  const context = useContext(DaiOptOutContext)

  if (context === undefined) {
    throw new Error(
      'useDaiOptOut must be used within a DaiOptOutContext.Provider',
    )
  }

  return {
    daiOptOut: context.daiOptOut,
    isLoading: context.isLoading,
    refresh: context.refresh,
    manage: context.manage,
  }
}

export default useDaiOptOut
